import SimpleRiskChipCell from '@app/src/components/Table/Cells/SimpleRiskChipCell'
import type { Risk } from '@app/src/types/resourceExplorer'
import { CloseOutlined } from '@mui/icons-material'
import { Box, Dialog, DialogContent, DialogTitle, IconButton, Stack, Typography } from '@mui/material'
import React from 'react'
import { useIntl } from 'react-intl'

type RiskDialogContent = {
  providerName: string
  location?: string
  industry?: string
  industryCode?: string
  countryName?: string
  risk?: Risk
}

export type RiskScreeningInfoDialogProps = {
  riskDialogContent?: RiskDialogContent
  setRiskDialogContent: (content: RiskDialogContent | undefined) => void
  isIndustry?: boolean
}

const RiskScreeningInfoDialog: React.FC<RiskScreeningInfoDialogProps> = ({
  riskDialogContent,
  setRiskDialogContent,
  isIndustry,
}) => {
  const { formatMessage } = useIntl()

  return (
    <Dialog open={Boolean(riskDialogContent)} onClose={() => setRiskDialogContent(undefined)} fullWidth maxWidth="sm">
      <DialogTitle display="flex" alignItems="flex-start">
        <Box flexGrow={1}>
          <Typography variant="h6">{riskDialogContent?.providerName}</Typography>
        </Box>
        <IconButton size="small" onClick={() => setRiskDialogContent(undefined)}>
          <CloseOutlined fontSize="small" />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Stack spacing={2}>
          <Stack direction="row" spacing={0.5} alignItems="center">
            <Typography fontWeight={700}>
              {isIndustry ? formatMessage({ id: 'schemas.organization.industry' }) : riskDialogContent?.location}:
            </Typography>
            <Typography>{isIndustry ? riskDialogContent?.industry : riskDialogContent?.countryName}</Typography>
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center">
            <Typography fontWeight={700}>{formatMessage({ id: 'schemas.risk.risk' })}:</Typography>
            <Stack direction="row" spacing={2} alignItems="center">
              <Typography>{riskDialogContent?.risk?.riskType.description}</Typography>
              <SimpleRiskChipCell riskStatus={riskDialogContent?.risk?.status} disableCell />
            </Stack>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default RiskScreeningInfoDialog
